import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UrunGrup} from '../model/urun-grup';
import {MultipleSelectModel} from '../model/multiple-select-model';
import {RestService} from '../providers/rest.service';

declare var $: any;

@Component({
  selector: 'app-urun-grup-sec-modal',
  templateUrl: './urun-grup-sec-modal.component.html',
  styleUrls: ['./urun-grup-sec-modal.component.css']
})
export class UrunGrupSecModalComponent implements OnInit {

  urunGruplar: UrunGrup[] = null;
  urunGrupArray: MultipleSelectModel[] = [];
  modalData: number = null;

  @Output() selectedUrunGrup = new EventEmitter<UrunGrup>();


  @Input()
  public set source(urunGruplar: UrunGrup[]) {
    if (urunGruplar != null) {
      this.urunGruplar = urunGruplar;
      this.reset();
    }
  }

  @Input()
  public set show(ts: number) {
    if (ts) {
      if (this.modalData !== ts) {
        this.modalData = ts;
        this.reset();
        $('#urun-grup-sec-modal').modal('show');
      }
    }
  }

  constructor(private restService: RestService) {
  }

  ngOnInit(): void {
  }

  getUrunGruplar(parent) {
    this.restService.urunGruplar(parent).subscribe(res => {
      if (res && res.length > 0) {
        if (parent == null) {
          this.urunGrupArray = [];
        }
        const r = new MultipleSelectModel();
        r.id = parent;
        r.childrens = res;
        this.urunGrupArray.push(r);
      }
      else{
        $('#urun-grup-sec-modal').modal('hide');
      }
    });
  }

  changedSelected(index: number, event: any) {
    const id = event.target.value;
    if (this.urunGrupArray.length > index) {
      this.urunGrupArray.splice(index + 1, this.urunGrupArray.length - 1);
    }
    let urunGrup = null;
    for (const e of this.urunGrupArray) {
      if (e.childrens != null) {
        for (const children of e.childrens) {
          if (children.id.toString() === id) {
            urunGrup = children;
            break;
          }
        }
      }
    }
    if (urunGrup != null) {
      this.getUrunGruplar(id);
      this.selectedUrunGrup.emit(urunGrup);
    }
  }

  private reset() {
    this.urunGrupArray = [];
    const r = new MultipleSelectModel();
    r.id = null;
    r.childrens = this.urunGruplar;
    this.urunGrupArray.push(r);
  }
}
